import {combineReducers} from 'redux';

import collections from './collectionsReducer';
import content from './contentReducer';
import eventRecordReducer from './eventRecordReducer';
import externalToolContextReducer from './externalToolContextReducer';
import lessonSpark from './lessonSparksReducer';
import likedContent from './likedContentReducer';
import userEmailsReducer from './userEmailsReducer';

export default combineReducers({
  userEmails: userEmailsReducer,
  externalToolContext: externalToolContextReducer,
  eventRecords: eventRecordReducer,
  lessonSpark,
  likedContent,
  collections,
  content
});
